import React from "react";
import FilledButton from "components/InterstellrComponents/FilledButton";

const FoundUserItem = ({ item, added, onPress }) => {
  return (
    <>
      <div className="flex flex-row justify-start items-center border relative border-slate-300 rounded-lg px-3 py-2">
        {item?.profileImage ? (
          <img
            src={item?.profileImage}
            alt={item?.title}
            className="w-12 h-12 object-cover rounded-full"
          />
        ) : null}

        <div className="flex flex-col">
          <h4 className="text-black font-medium text-base px-4">
            {item?.firstname ?? ""} {item?.lastname ?? ""}
          </h4>

          <h4 className="text-black font-normal text-xs px-4">
            {item?.email ?? ""}
          </h4>
        </div>

        <div style={{ flex: 1 }} />

        <div className="w-1/3">
          <FilledButton
            onPress={() => onPress(item)}
            text={added ? "Remove" : "Nominate"}
            backgroundColor={added ? "#ff0000" : "#5153F5"}
            borderRadius={96}
          />
        </div>
      </div>
    </>
  );
};

export default FoundUserItem;
